// tslint:disable:variable-name
import { SupportedPosition } from 'src/packages/warehouse/models/supported-position';
import { StockObjectType } from 'src/packages/warehouse/models/stock-object';

// Enum für die Lagerbuchungstypen, die als Routenparameter übergeben werden
export type StockBookingType = 'TRASH' | 'MOVE' | 'MANUAL' | 'ORDER';

// Konstanten für die Lagerbuchungstypen
export const STOCK_BOOKING_TYPE_TRASH: StockBookingType = 'TRASH';
export const STOCK_BOOKING_TYPE_MOVE: StockBookingType = 'MOVE';
export const STOCK_BOOKING_TYPE_MANUAL: StockBookingType = 'MANUAL';
export const STOCK_BOOKING_TYPE_ORDER: StockBookingType = 'ORDER';

// Anzeige Namen für die Lagerbuchungstypen
export const STOCK_BOOKING_DISPLAY_NAMES = {
  [STOCK_BOOKING_TYPE_TRASH]: $localize`Entsorgen`,
  [STOCK_BOOKING_TYPE_MOVE]: $localize`Umlagern`,
  [STOCK_BOOKING_TYPE_MANUAL]: $localize`Manuell verbrauchen`,
  [STOCK_BOOKING_TYPE_ORDER]: $localize`Bestellung`,
};

/**
 * Klasse für die Lagerbuchung zwischen zwei Lagern
 */
export class StockBooking {
  // Art der Lagerbuchung
  type!: StockBookingType;
  // Quelllager ID (StockObject idR Bufferstock)
  source_id?: number;
  // Quelllager Type (Type des StockObjects) (#778)
  source_type?: StockObjectType;
  // Ziellager ID (StockObject idR Bufferstock)
  target_id?: number;
  // Ziellager Type (Type des StockObjects) (#778)
  target_type?: StockObjectType;
  // Positionen der Buchung
  positions: SupportedPosition[] = [];
  // Beschreibung der Buchung
  description!: string;

}
